import type {ThemeVariablesType} from "../../variables";
import {SpacialFn, NormalizedPaddingProp, UnnormalizedPaddingProp} from "@yosmanyga/core-style";

const normalizePadding = (
    padding: UnnormalizedPaddingProp | undefined,
    theme: {variables: ThemeVariablesType}
): NormalizedPaddingProp | undefined => {
    padding = SpacialFn.normalizePadding(padding);

    if (
        !padding
        || typeof padding !== 'object'
        || padding['raw'] == true
    ) {
        return padding;
    }

    if (padding.top) {
        padding.top = theme.variables.spacing(padding.top)
    }

    if (padding.bottom) {
        padding.bottom = theme.variables.spacing(padding.bottom)
    }

    if (padding.left) {
        padding.left = theme.variables.spacing(padding.left)
    }

    if (padding.right) {
        padding.right = theme.variables.spacing(padding.right)
    }

    return padding;
}

export {
    normalizePadding
}